import React from 'react';
import { NavLink } from 'react-router-dom';
import Tag from './Tag';
import Button from './Button';
import './WorkComponent.css';

const WorkComponent = ({ id, image, title, description, tags }) => {
    return (
        <div className="work-component">
            <img src={image} alt={title} />
            <div className="content">
                <h2 className='work-component-title'>{title}</h2>
                <p className='work-shortdescription'>{description}</p>
                <div className="tags">
                    {tags.map((tag, index) => (
                        <Tag key={index} text={tag} />
                    ))}
                </div>
                <div className='work-button'>
                    <NavLink to={`/work/${id}`}>
                        <Button text="Learn More" />
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export default WorkComponent;
